var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSurfaceJaune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.155,
    height: 35.564,
    viewBox: "0 0 37.155 35.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebbc02;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #ebbc02;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_surface",
    "data-name": "Icon surface",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_282",
    "data-name": "Groupe 282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1928",
    "data-name": "Trac\\xE9 1928",
    className: "cls-1",
    d: "M6.4,3.191,5.66,1H1.788V4.984c3.451.622,3.451.622,4.61-1.427",
    transform: "translate(-1.012 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1929",
    "data-name": "Trac\\xE9 1929",
    className: "cls-1",
    d: "M36.776,32.907c2.807.556,1.615,2.763,1.876,4.566H34.194V33.638l2.213-.731",
    transform: "translate(-2.671 -2.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1930",
    "data-name": "Trac\\xE9 1930",
    className: "cls-1",
    d: "M36.4,5.751c3.317-.346,1.909-2.641,2.336-4.565H34.675c-1.427,2.238-.927,3.7,1.358,4.565",
    transform: "translate(-2.666 -1.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1931",
    "data-name": "Trac\\xE9 1931",
    className: "cls-1",
    d: "M3.443,33.278c-2.833.341-1.478,2.566-1.98,4.2H5.85c.554-1.688,1.179-3.517-1.67-4.2",
    transform: "translate(-1.007 -2.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1932",
    "data-name": "Trac\\xE9 1932",
    className: "cls-2",
    d: "M3.849,6.194V16.786",
    transform: "translate(-1.044 -1.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1933",
    "data-name": "Trac\\xE9 1933",
    className: "cls-2",
    d: "M17.173,3.226H6.846",
    transform: "translate(-1.337 -1.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1934",
    "data-name": "Trac\\xE9 1934",
    className: "cls-2",
    d: "M3.849,22.519V32.745",
    transform: "translate(-1.044 -2.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1935",
    "data-name": "Trac\\xE9 1935",
    className: "cls-2",
    d: "M36.442,6.194V16.42",
    transform: "translate(-2.706 -1.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1936",
    "data-name": "Trac\\xE9 1936",
    className: "cls-2",
    d: "M17.173,35.875H6.846",
    transform: "translate(-1.337 -2.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1937",
    "data-name": "Trac\\xE9 1937",
    className: "cls-2",
    d: "M36.442,22.519V32.38",
    transform: "translate(-2.706 -2.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1938",
    "data-name": "Trac\\xE9 1938",
    className: "cls-2",
    d: "M23.33,35.5h9.958",
    transform: "translate(-2.502 -2.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1939",
    "data-name": "Trac\\xE9 1939",
    className: "cls-1",
    d: "M22.879,3.191,22.141,1H18.085V5.442c2-.286,4.233.895,4.794-1.885",
    transform: "translate(-1.863 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1940",
    "data-name": "Trac\\xE9 1940",
    className: "cls-1",
    d: "M22.879,35.469c-.538-2.585-2.541-2.271-4.794-2.111v4.12h4.426V35.834",
    transform: "translate(-1.863 -2.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1941",
    "data-name": "Trac\\xE9 1941",
    className: "cls-1",
    d: "M3.436,17.324c-3.6.222-.975,2.682-2.436,4.384H5.725C5.3,20.2,8.016,17.679,4.173,17.324",
    transform: "translate(-1 -1.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1942",
    "data-name": "Trac\\xE9 1942",
    className: "cls-1",
    d: "M36.4,16.953C33.088,17.3,34.5,19.6,34.028,21.7h4.8c-.534-2,.84-4.08-2.05-4.749",
    transform: "translate(-2.668 -1.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1943",
    "data-name": "Trac\\xE9 1943",
    className: "cls-2",
    d: "M20.333,11.759V22.434",
    transform: "translate(-1.99 0.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1944",
    "data-name": "Trac\\xE9 1944",
    className: "cls-2",
    d: "M22.528,19.551H12.84",
    transform: "translate(0.809 -2.005)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurfaceJaune);
export default __webpack_public_path__ + "static/media/icon_surface_jaune.dd2c2d7847d3fdad19b7c54585b7c589.svg";
export { ForwardRef as ReactComponent };